import React from 'react';
import { useLocation } from 'react-router-dom';

// Light-background pages skip the dark shell's glow + noise overlays (they sit above page content).
const LIGHT_ROUTES = ['/tfb-october-report'];

const Layout = ({ children }) => {
    const light = LIGHT_ROUTES.includes(useLocation().pathname.replace(/\/$/, ''));
    return (
        <div className="min-h-screen bg-gray-900 font-body text-surface-200 relative overflow-x-hidden selection:bg-indigo-500/30">
            {/* Animated Gradient Background */}
            <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
                <div className="absolute inset-0 bg-black" style={{
                    background: `radial-gradient(circle at 10% 20%, rgba(128, 0, 128, 0.4), transparent 50%),
                                 radial-gradient(circle at 80% 90%, rgba(0, 0, 255, 0.4), transparent 50%),
                                 radial-gradient(circle at 50% 50%, rgba(59, 130, 246, 0.3), transparent 50%)`,
                    backgroundSize: '250% 250%',
                    animation: 'moveGradient 25s ease infinite',
                }}></div>

                {/* Grain Texture */}
                <div
                    className="absolute inset-0 opacity-20 mix-blend-overlay"
                    style={{ backgroundImage: 'url("https://www.transparenttextures.com/patterns/grain.png")' }}
                ></div>
            </div>

            {!light && (
                <>
                    {/* Noise Texture */}
                    <div className="noise-overlay"></div>

                    {/* Viewport Inner Glow */}
                    <div className="viewport-glow"></div>
                </>
            )}

            {/* Page Content */}
            <div className="relative z-10">
                {children}
            </div>

            {/* Keyframe for animated background */}
            <style>{`
                @keyframes moveGradient {
                    0% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                }
            `}</style>
        </div>
    );
};

export default Layout;
